import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/auth/ProtectedRoute';
import MainLayout from './components/Layout/MainLayout';
import Overview from './components/pages/Overview';
import Agents from './components/pages/Agents';
import AgentDetails from './components/pages/AgentDetails';
import Alerts from './components/pages/Alerts';
import Compliance from './components/pages/Compliance';
import Vulnerabilities from './components/pages/Vulnerabilities';
import Events from './components/pages/Events';
import MitreAttack from './components/pages/MitreAttack';
import MitreAttackDetails from './components/pages/MitreAttackDetails';
import SCA from './components/pages/SCA';
import ScaDetails from './components/pages/ScaDetails';
import DeployAgent from './components/pages/DeployAgent';
import NetworkDiscovery from './components/pages/NetworkDiscovery';
import SubdomainScanner from './components/pages/SubdomainScanner';
import WAFScanner from './components/pages/WAFScanner';
import Packages from './components/pages/Packages';
import Attacks from './components/pages/Attacks';
import AgentVulnerabilities from './components/pages/AgentVulnerabilities';
import SysScan from './components/pages/SysScan';
import SshActivity from './components/pages/SshActivity';
import DockerInfo from './components/pages/DockerInfo';
import Groups from './components/pages/Groups';
import AuthRedirect from './components/auth/AuthRedirect';
import SetupInfrastructure from './pages/SetupInfrastructure';
import ManageService from './pages/ManageService';
import ExecuteCustomCommands from './pages/ExecuteCustomCommands';
import DevopsMonitoring from './pages/DevopsMonitoring';
import RemoteConnections from './pages/RemoteConnections';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#6366f1',
    },
    secondary: {
      main: '#8b5cf6',
    },
    background: {
      default: '#f8fafc',
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <AuthProvider>
        <Router>
          <Routes>
              <Route path="/" element={
                <ProtectedRoute>
                  <Overview />
                </ProtectedRoute>
              } />
              <Route path="/agents" element={
                <ProtectedRoute>
                  <Agents />
                </ProtectedRoute>
              } />
              <Route path="/agents/:id" element={
                <ProtectedRoute>
                  <AgentDetails />
                </ProtectedRoute>
              } />
              <Route path="/agents/:id/packages" element={
                <ProtectedRoute>
                  <Packages />
                </ProtectedRoute>
              } />
              <Route path="/agents/:id/attacks" element={
                <ProtectedRoute>
                  <Attacks />
                </ProtectedRoute>
              } />
              <Route path="/agents/:id/vulnerabilities" element={
                <ProtectedRoute>
                  <AgentVulnerabilities />
                </ProtectedRoute>
              } />
              <Route path="/alerts" element={
                <ProtectedRoute>
                  <Alerts />
                </ProtectedRoute>
              } />
              <Route path="/compliance" element={
                <ProtectedRoute>
                  <Compliance />
                </ProtectedRoute>
              } />
              <Route path="/vulnerabilities" element={
                <ProtectedRoute>
                  <Vulnerabilities />
                </ProtectedRoute>
              } />
              <Route path="/events" element={
                <ProtectedRoute>
                  <Events />
                </ProtectedRoute>
              } />
              <Route path="/mitre-attack" element={
                <ProtectedRoute>
                  <MitreAttack />
                </ProtectedRoute>
              } />
              <Route path="/mitre-attack/details/:tactic/:agentId" element={
                <ProtectedRoute>
                  <MitreAttackDetails />
                </ProtectedRoute>
              } />
              <Route path="/sca" element={
                <ProtectedRoute>
                  <SCA />
                </ProtectedRoute>
              } />
              <Route path="/sca-details/:agentId" element={
                <ProtectedRoute>
                  <ScaDetails />
                </ProtectedRoute>
              } />
              <Route path="/network-discovery" element={
                <ProtectedRoute>
                  <NetworkDiscovery />
                </ProtectedRoute>
              } />
              <Route path="/subdomain-scanner" element={
                <ProtectedRoute>
                  <SubdomainScanner />
                </ProtectedRoute>
              } />
              <Route path="/waf-scanner" element={
                <ProtectedRoute>
                  <WAFScanner />
                </ProtectedRoute>
              } />
              <Route path="/sysscan" element={
                <ProtectedRoute>
                  <SysScan />
                </ProtectedRoute>
              } />
              <Route path="/ssh-activity" element={                <ProtectedRoute>                  <SshActivity />                </ProtectedRoute>              } />              <Route path="/deploy-agent" element={
                <ProtectedRoute>
                  <DeployAgent />
                </ProtectedRoute>
              } />
              <Route path="/docker-info" element={
                <ProtectedRoute>
                  <DockerInfo />
                </ProtectedRoute>
              } />
              <Route path="/groups" element={
                <ProtectedRoute>
                  <Groups />
                </ProtectedRoute>
              } />
              <Route path="/setup-infrastructure" element={
                <ProtectedRoute>
                  <SetupInfrastructure />
                </ProtectedRoute>
              } />
              <Route path="/manage-service" element={
                <ProtectedRoute>
                  <ManageService />
                </ProtectedRoute>
              } />
              <Route path="/execute-custom-commands" element={
                <ProtectedRoute>
                  <ExecuteCustomCommands />
                </ProtectedRoute>
              } />
              <Route path="/devops-monitoring" element={
                <ProtectedRoute>
                  <DevopsMonitoring />
                </ProtectedRoute>
              } />
              <Route path="/remote-connections" element={
                <ProtectedRoute>
                  <RemoteConnections />
                </ProtectedRoute>
              } />
              <Route path="/auth/redirect" element={<AuthRedirect />} />
            </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
